export class Locale {
    altTip?: string;
    settingsTip?: string;
    floatLeft?: string;
    floatRight?: string;
    center?: string;
    restore?: string;
    inputTip?: string;
}

export class I18n {
    config: Locale;
    constructor(config: Locale) {
        this.config = { ...defaultLocale, ...config };
    }
    findLabel(key: string): string | null {
        if (this.config) {
            return Reflect.get(this.config, key) as string | null;
        }
        return null;
    }
}

const defaultLocale: Locale = {
    floatLeft: "left",
    floatRight: "right",
    center: "center",
    restore: "restore",
    settingsTip: "Settings",
    altTip: "Drag to resize (keeps proportions)",
    inputTip: "Press enter key to apply change!",
};

export { defaultLocale };
